// extracted by mini-css-extract-plugin
export default {"root":"QuoteSection__root--cWMUe","header":"QuoteSection__header--vp3UD","subtotal":"QuoteSection__subtotal--ZcQ1l","items":"QuoteSection__items--VqkF7"};